import React from 'react';
var SuccessAndRedirect = function () {
    return (React.createElement("div", { className: 'w-96 text-center' },
        React.createElement("h2", { className: 'mb-4' }, "Success!"),
        React.createElement("p", { className: 'text-secondary' }, "You should be redirected to your app in a few seconds. You can close this window now.")));
};
export default SuccessAndRedirect;
